@if (errorListService.errors$ | async; as errors) {
  <div>
    @for (error of errors; track error) {
      <div class="error-list">
        <mat-icon>warning</mat-icon><span>{{ error | translate }}</span>
      </div>
    }
  </div>
}
